import { Permission } from "../../../types/Permissions";
import { authGet, authPut, authDelete } from "../../auth/auth";
import {
  GetPolicyResponse,
  ListPoliciesResponse,
  PolicyAllRulesYaml,
  PolicyWithRules,
  PolicyRuleOverride,
} from "./types";

export const fetchPolicy = (
  deploymentId: string,
  policySlug: string
): Promise<GetPolicyResponse> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policySlug}`;
  return authGet<GetPolicyResponse>(path);
};

/*
 * Fetches policies and rulesets in those policies from deployment
 */
export const fetchPoliciesIfPermitted = (
  deploymentId: string,
  permissions: Permission[],
  withStats: boolean = true
): Promise<ListPoliciesResponse> => {
  if (!permissions.includes(Permission.panel_policy)) {
    return Promise.resolve({ policies: [], rulesets: [] });
  }

  let path = `/api/agent/deployments/${deploymentId}/policies`;
  if (withStats) {
    path = path + "?stats=1";
  } else {
    path = path + "?stats=0";
  }
  return authGet<ListPoliciesResponse>(path);
};

export const fetchRulesYamlFromPolicy = (
  deploymentId: string,
  policySlug: string
): Promise<PolicyAllRulesYaml> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policySlug}/rules`;
  return authGet<PolicyAllRulesYaml>(path);
};

export const savePolicy = (
  deploymentId: string,
  policy: PolicyWithRules
): Promise<PolicyWithRules> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policy.slug}`;
  return authPut<PolicyWithRules, PolicyWithRules>(path, policy);
};

type OverridesRequestBody = {
  overrides: PolicyRuleOverride[];
};

export const savePolicyRuleOverrides = (
  deploymentId: string,
  policy: PolicyWithRules
): Promise<PolicyWithRules> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policy.slug}/overrides`;
  return authPut<OverridesRequestBody, PolicyWithRules>(path, {
    overrides: policy.overrides,
  });
};

export const deletePolicy = (
  deploymentId: string,
  policy: PolicyWithRules
): Promise<PolicyWithRules> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policy.slug}`;
  return authDelete<PolicyWithRules>(path);
};
